module.exports = __webpack_public_path__ + "static/banner-image-b31625b8cfacecfbc863fef9c9bcff52.jpg";